const Reports = () => import('@/modules/reports/index.vue');
const ReportsTotals = () => import('@/modules/reports/totals/index.vue');
const ReportsDaily = () => import('@/modules/reports/daily/index.vue');
const ReportsMonthly = () => import('@/modules/reports/monthly/index.vue');
const ReportsProducts = () => import('@/modules/reports/products/index.vue');
const ReportsServices = () => import('@/modules/reports/services/index.vue');
const ReportsEmployees = () => import('@/modules/reports/employees/index.vue');
const ReportsVatOverview = () =>
  import('@/modules/reports/vat-overview/index.vue');
const Insights = () => import('@/modules/reports/insights/index.vue');

import { useUserStore } from '@/stores/user';
import { redirectRoute } from '../helpers';

export default {
  path: 'reports',
  name: 'reports',
  component: Reports,
  beforeEnter: (to) => {
    const { hasFeatureFlag } = useUserStore();

    if (hasFeatureFlag('module-reports') && to.name === 'reports') {
      return redirectRoute({ name: 'reports-totals' });
    }
  },
  meta: {
    moduleName: 'reports',
    role: 'reports',
    disabledPlans: ['pro-light'],
    // Pro-light salons with historical order data get module-reports from the backend (SALON-3131)
    disabledPlansOverrideFlag: 'module-reports',
  },
  children: [
    {
      path: 'totals',
      name: 'reports-totals',
      component: ReportsTotals,
      meta: {
        featureFlag: 'module-reports',
      },
    },
    {
      path: 'daily',
      name: 'reports-daily',
      component: ReportsDaily,
      meta: {
        featureFlag: 'module-reports',
      },
    },
    {
      path: 'monthly',
      name: 'reports-monthly',
      component: ReportsMonthly,
      meta: {
        featureFlag: 'module-reports',
      },
    },
    {
      path: 'products',
      name: 'reports-products',
      component: ReportsProducts,
      meta: {
        featureFlag: 'module-reports',
      },
    },
    {
      path: 'services',
      name: 'reports-services',
      component: ReportsServices,
      meta: {
        featureFlag: 'module-reports',
      },
    },
    {
      path: 'employees',
      name: 'reports-employees',
      component: ReportsEmployees,
      meta: {
        featureFlag: 'module-reports',
      },
    },
    {
      path: 'vat-overview',
      name: 'reports-vat-overview',
      component: ReportsVatOverview,
      meta: {
        featureFlag: 'module-reports',
      },
    },
    {
      path: 'insights',
      name: 'reports-insights',
      component: Insights,
      meta: {
        moduleName: 'insights',
        unleash: 'Insights',
      },
    },
  ],
};
